import {Component, Injector, OnInit} from '@angular/core';
import {BasePropostaComponent} from '../base-proposta';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AppComponent} from '../../../app.component';
import {CategoriaPlanoService} from '../../../core/services/categoria_plano.service';
import {RdService} from '../../../core/services/rd.service';
import {CupomService} from '../../../core/services/cupom.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {CepService} from '../../../core/services/cep.service';
import {Meta, Title} from '@angular/platform-browser';
import {ProdutoService} from '../../../core/services/produto.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-pagamento-debito',
    templateUrl: './pagamento-debito.component.html',
    styleUrls: ['./pagamento-debito.component.sass']
})
export class PagamentoDebitoComponent extends BasePropostaComponent implements OnInit {
    public form: FormGroup;
    maskDigitoConta: string;
    maskDigitoAgencia: string;
    BB = '001';
    BRB = '070';
    CEF = '104';
    BRADESCO = '237';
    ITAU = '341';
    SANTANDER = '356';
    minLengthAgencia = 4;
    maxLengthAgencia = 4;
    minLengthConta = 6;
    maxLengthConta = 12;
    constructor(
        protected injector: Injector,
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public router: Router,
        public formBuilder: FormBuilder,
        public cepService: CepService,
        public rdService: RdService,
        public toast: ToastrService,
        public categoriaPlanoService: CategoriaPlanoService,
        public appComponent: AppComponent,
        public titleService: Title,
        public meta: Meta,
        public produtoService: ProdutoService,
        public deviceService: DeviceDetectorService,
    ) {
        super(injector);
        const proposta = this.getPropostaParaStorage();

        this.form = formBuilder.group({
            debitoDataPagamento: new FormControl(proposta ? proposta.debitoDataPagamento : null, [Validators.required]),
            debitoAgencia: new FormControl(proposta ? proposta.debitoAgencia : null, [Validators.required]),
            debitoContaCorrente: new FormControl(proposta ? proposta.debitoContaCorrente : null, [Validators.required]),
            // tslint:disable-next-line:max-line-length
            debitoCodigoBanco: new FormControl(proposta && proposta.debitoCodigoBanco ? proposta.debitoCodigoBanco : '', [Validators.required]),
            bairro: new FormControl(proposta ? proposta.bairro : null, [Validators.required]),
            cep: new FormControl(proposta ? proposta.cep : null, [Validators.required]),
            codCidade: new FormControl(proposta ? proposta.codCidade : null, [Validators.required]),
            complemento: new FormControl(proposta ? proposta.complemento : null, []),
            logradouro: new FormControl(proposta ? proposta.logradouro : null, [Validators.required]),
            numero: new FormControl(proposta ? proposta.numero : null, [Validators.required]),
            termoDeUsoAceito: new FormControl(null, [Validators.required]),
        });

        this.carregarEnderecoLocalStorage(this.form);
        this.carregarContaLocalStorage();
    }

    termoDeUsoAceitoEmit($event) {
        this.form.get('termoDeUsoAceito').setValue($event ? true : null);
    }

    showError(campo) {
        return this.form.controls[campo].errors && !this.form.controls[campo].pristine;
    }

    carregarContaLocalStorage() {
        const proposta = this.getPropostaParaStorage();

        if (!proposta) {
            return;
        }

        if (proposta.debitoCodigoBanco) {
            this.form.get('debitoCodigoBanco').setValue(proposta.debitoCodigoBanco);
        }

        if (proposta.debitoAgencia) {
            this.form.get('debitoAgencia').setValue(proposta.debitoAgencia);
        }

        if (proposta.debitoContaCorrente) {
            this.form.get('debitoContaCorrente').setValue(proposta.debitoContaCorrente);
        }

        if (proposta.debitoDataPagamento) {
            this.form.get('debitoDataPagamento').setValue(proposta.debitoDataPagamento.padStart(2, '0'));
        }
    }

    async submit() {
        if (this.form.valid) {
            const result = await this.propostaService.pagamentoDebitoConta(this.form.value);

            if (result.status === 200 || result.status === 201) {
                const queryRD = {
                    event_type: 'CONVERSION',
                    event_family: 'CDP',
                    payload: {
                        conversion_identifier: 'Carrinho_Site_Passo_2',
                        email: this.emailCliente,
                        cf_bairro: this.form.get('bairro').value,
                        cf_cep: this.form.get('cep').value,
                        cf_complemento: this.form.get('complemento').value,
                        cf_endereco: this.form.get('logradouro').value,
                        cf_numero: this.form.get('numero').value,
                        cf_tipobanco: 'Cartao de Débito'
                    }
                };

                await this.rdService.updateEventByIdentifier(queryRD);

                this.addPropostaParaStorage(this.form.value);
                await this.router.navigate(['seguranca']);
            } else if (result.status === 400 || result.status === 409) {
                this.toast.error(result.error.description);
            } else {
                if (result.error) {
                    this.toast.error(result.error.description, '', {
                        timeOut: 5000
                    });
                } else {
                    this.toast.error('Ocorreu um erro ao processar a requisição', '', {
                        timeOut: 8000
                    });
                }
            }
        }
    }

    getErrorMessage(field: string) {

        const input = this.form.get(field);
        return input.hasError('required') ? 'Campo obrigatório' :
            input.hasError('cpf') ? 'CPF inválido' :
                input.hasError('invalidDate') ? 'Insira uma data válida.' :
                    input.hasError('notSame') ? 'E-mail não confere.' :
                        input.hasError('email') ? 'E-mail inválido.' :
                            '';
    }

    async ngOnInit() {
        await this.inOnInit();
    }

    defaultValue() {
        this.maskDigitoAgencia = undefined;
        this.minLengthAgencia = undefined;
        this.maxLengthAgencia = undefined;
        this.form.controls.debitoAgencia.reset();
        this.form.controls.debitoAgencia.updateValueAndValidity();
        this.form.controls.debitoContaCorrente.reset();
        this.form.controls.debitoContaCorrente.updateValueAndValidity();
    }

    isAgenciaValid(event: any) {
        if (event != null && event.length >= 3) {
            this.validaBanco(true, event);
        }
    }

    isContaValid(event: any) {
        this.validaBanco(false, event);
    }

    validaBanco(agencia: boolean, event: any) {
        if (this.form.controls.debitoCodigoBanco.valid && this.form.controls.debitoCodigoBanco.value !== '') {
            switch (this.form.controls.debitoCodigoBanco.value) {
                case this.BB: {
                    (agencia) ?
                    this.validaAgencia(
                        4,
                        true,
                        true,
                        this.BB,
                        event
                    ) : this.validaConta(
                        6,
                        '00000-0',
                        this.BB,
                        event
                    );
                    break;
                }
                case this.BRB: {
                    (agencia) ?
                    this.validaAgencia(
                        3,
                        false,
                        false,
                        this.BRB,
                        event
                    ) : this.validaConta(
                        7,
                        '000000-0',
                        this.BRB,
                        event
                    );
                    break;
                }
                case this.CEF: {
                    (agencia) ?
                    this.validaAgencia(
                        4,
                        false,
                        true,
                        this.CEF,
                        event
                    ) : this.validaConta(
                        13,
                        '000.000000000-0',
                        this.CEF,
                        event
                    );
                    break;
                }
                case this.BRADESCO: {
                    (agencia) ?
                    this.validaAgencia(
                        4,
                        false,
                        true,
                        this.BRADESCO,
                        event
                    ) : this.validaConta(
                        8,
                        '0000000-0',
                        this.BRADESCO,
                        event
                    );
                    break;
                }
                case this.ITAU: {
                    (agencia) ?
                    this.validaAgencia(
                        4,
                        false,
                        true,
                        this.ITAU,
                        event
                    ) : this.validaConta(
                        6,
                        '00000-0',
                        this.ITAU,
                        event
                    );
                    break;
                }
                case this.SANTANDER: {
                    (agencia) ?
                    this.validaAgencia(
                        4,
                        true,
                        true,
                        this.SANTANDER,
                        event
                    ) : this.validaConta(
                        9,
                        '00000000-0',
                        this.SANTANDER,
                        event
                    );
                    break;
                }
            }
        }
    }

    validaAgencia(maxLength: number, regex: boolean, digitoVerificador: boolean, banco: string, event: any) {
        let valid = false;
        if (event != null && event.length === 0) {
            this.maskDigitoAgencia = undefined;
            this.minLengthAgencia = maxLength;
            this.maxLengthAgencia = maxLength;
        }
        this.maskDigitoAgencia = this.setMaskAgencia(banco);
        if (this.form.controls.debitoAgencia.valid && this.form.controls.debitoAgencia.value !== '') {
            const regExpDV = new RegExp('.(10)|[0-9]{4}[xX]');
            const regExp = new RegExp('.(10)|[0-9]{4}');
            const agencia = this.form.controls.debitoAgencia.value;
            if (regex && digitoVerificador) {
                valid = (regExp.test(agencia) || regExpDV.test(agencia));
            }
            if (!regex) {
                valid = +agencia.length === +this.minLengthAgencia;
            }
            if (!valid) {
                this.toast.error('Agéncia ou Digito Verificador inválido!', '', {
                    timeOut: 8000
                });
            }
        }
    }

    setMaskAgencia(banco: string): string {
        if (!(banco === this.CEF || banco === this.SANTANDER || banco === this.BRB)) {
            this.minLengthAgencia = 4;
            this.maxLengthAgencia = 6;
            return  '9999-9';
        }
        if (banco === this.BRB) {
            this.minLengthAgencia = 3;
            this.maxLengthAgencia = 3;
            return '999';
        }
        this.minLengthAgencia = 4;
        this.maxLengthAgencia = 4;
        return '9999';
    }

    validaConta(lengthConta: number, maskConta: string, banco: string, event: any) {
        if (this.form.controls.debitoContaCorrente.value !== '') {
            if (banco === this.CEF) {
                this.validaContaCEF(event);
                return;
            }
            this.minLengthConta = lengthConta;
            this.maxLengthConta = lengthConta;
            this.maskDigitoConta = maskConta;
            if ((event != null) && (event.length >= lengthConta - 1) &&  (event.length < lengthConta)) {
                this.toast.error('Dígitos insuficientes! o mínimo é de ' + lengthConta + ' dígitos!', '', {
                    timeOut: 8000
                });
            }
        }
    }

    validaContaCEF(event: any) {
        this.minLengthConta = 13;
        this.maxLengthConta = 19;
        let valid = false;
        if (event && event.length === 0) {
            this.maskDigitoConta = undefined;
        }
        if ((event && event.length >= 12 && event.length <= 19)) {
            const conta = event;
            switch (conta.substring(0, 3)) {
                case '001': {
                    this.maskDigitoConta = '000.000000000-0';
                    valid = true;
                    break;
                }
                case '002': {
                    this.maskDigitoConta = '000.000000000-0';
                    valid = true;
                    break;
                }
                case '013': {
                    this.maskDigitoConta = '000.00000000-0';
                    valid = true;
                    break;
                }
                case '023': {
                    this.maskDigitoConta = '000.000000000-0';
                    valid = true;
                    break;
                }
                case '128': {
                    this.minLengthConta = 14;
                    this.maskDigitoConta = '0000.000000000000-0';
                    if (conta.substring(0, 4) !== '1288') {
                        this.toast.error('Contas da caixa devem iniciar com o número de operação! (001, 002, 013, 023 ou 1288)', '', {
                            timeOut: 8000
                        });
                        valid = false;
                        return;
                    }
                    valid = true;
                    break;
                }
                default: {
                    this.toast.error('Contas da caixa devem iniciar com o número de operação! (001, 002, 013, 023 ou 1288)', '', {
                        timeOut: 8000
                    });
                    valid = false;
                    break;
                }
            }
        }
    }


}
